import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import style from './Presentacion.module.css'
import imagen from '../../../../utils/images/box-1.png'

const Presentacion = () => {
  const { t } = useTranslation()
  const [hover, setHover] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className={style.container}>
      <div className={style.divIzq}>
        <div
          className={style.circulosContenedor}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <div className={hover ? style.circulo2Hover : style.circulo2}>
            <div className={hover ? style.circulo1Hover : style.circulo1}>
              <div className={hover ? style.circuloImagenHover : style.circuloImagen}>
                <img
                  className={hover ? style.imagenHover : style.imagen}
                  src={imagen}
                  alt="Business Solution"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.divDer}>
        <p className={style.titulo}>
          {t('Products.BusinessSolution.Presentation.title')}
        </p>
        <p className={style.text1}>
          {t('Products.BusinessSolution.Presentation.text1')}
        </p>
        <p className={style.text2}>
          {t('Products.BusinessSolution.Presentation.text2')}
        </p>
      </div>
    </div>
  )
}

export default Presentacion
